module.exports = __webpack_public_path__ + "img/tarot-major-arcana-13.9ddab830.png";